export default "__VITE_ASSET__CZuPcx3R__"